<template>
  <nav class="navbar navbar-lg navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid">
      <div class="text-left scales-logo-white" @click="getTop()">
        <img src="../../../static/img/landing/SCALES-LOGO-WHITE.png" class="img-fluid" />
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
        </ul>
        <div class="dropdown">
          <button class="btn btn-outline-white dropdown-toggle mr-2" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('navbar.language')}}
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" @click="changeLanguage('en')">
              {{$t('languageChoice.English')}}
            </button>
            <!--<button class="dropdown-item" @click="changeLanguage('zh')">
              {{$t('languageChoice.Chinese')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('jp')">
              {{$t('languageChoice.Japanese')}}
            </button>-->
          </div>
        </div>
        <div class="dropdown">
          <button class="btn btn-outline-white dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('navbar.myAccount')}}
          </button>
          <div class="dropdown-menu">
            <router-link class="dropdown-item" to="/user/info">
              {{$t('navbar.setting')}}
            </router-link>
            <button class="dropdown-item" @click="signOut">
              {{$t('navbar.signOut')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style />

<script type="text/javascript">
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import Cookies from 'js-cookie'
export default {
  data: function () {
    return {
    }
  },
  mounted() {
  },
  methods: {
    signOut() {
      NmsClient.send(
        RestCfg.POST, {
          'reqType': 'user-logout'
        },
        () => {

        },
        null
      )
      Cookies.remove('tokenId')
      this.$router.push({ path: '/user/login' })
    },
    changeLanguage(language) {
      let setLanguage = language
      Cookies.set('language', setLanguage, { path: '/', expires: Env.COOKIES_TTL })
      this.$i18n.locale = setLanguage
    },
    getTop() {
      if (Cookies.get('tokenId')) this.$router.push({ path: '/user/top' })
      else this.$router.push({ path: '/user/landing' })
    }
  }
}
</script>
<style scoped>

@media (max-width: 991.98px){
.navbar-expand-lg .navbar-collapse {
    display: -ms-flexbox!important;
    display: -webkit-box!important;
    display: flex!important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
}
.navbar-expand-lg .navbar-toggler {
    display: none;
}
}
.navbar {
  font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}

.scales-logo-white {
  width:60px;
  margin-left: 1.5rem;
  cursor: pointer;
}
.collapse{
  position: relative;
  margin:1.5rem 1.5rem
}
.navbar{
  padding:0px 0px
}
</style>



// WEBPACK FOOTER //
// src/components/user/navbar.vue